import Cookies from "universal-cookie";

import { func_validation } from "./func_validation";

const cookies = new Cookies();

export const func_cookie = {

    getCookie,

    getCookieAll,
    getCookieValue,
    getCookieValueParseObj,

    setCookie,
    setCookieStringify,
    setCookieStringify_append,

    removeCookie,
    removeAllCookies,

};

function getCookie() {
    return cookies;
}

function getCookieAll() {
    return cookies.getAll();
}

function getCookieValue(cookieName) {
    if (func_validation.isStringTrimNotEmpty(cookieName)) {
        let cookieValue = cookies.get(cookieName, { doNotParse: true });
        if (func_validation.isStringTrimNotEmpty(cookieValue)) return cookieValue;
    }
    return "";
}

function getCookieValueParseObj(cookieName) {
    if (func_validation.isStringTrimNotEmpty(cookieName)) {
        let cookieValue = cookies.get(cookieName, { doNotParse: false });
        if (func_validation.isObjectNotEmpty(cookieValue)) return cookieValue;
    }
    return {};
}

function setCookie(cookieName, cookieValue, cookieOptions) {
    if (func_validation.isStringTrimNotEmpty(cookieName) && 
        (func_validation.isStringTrimNotEmpty(cookieValue) ||
            func_validation.isNumberValid(cookieValue))) {
        
        if (func_validation.isObjectNotEmpty(cookieOptions)) {
            cookies.set(cookieName, cookieValue, cookieOptions);
        } else cookies.set(cookieName, cookieValue);

        return true;
    } else return false;
}

function setCookieStringify(cookieName, cookieValue, cookieOptions) {
    if (func_validation.isStringTrimNotEmpty(cookieName) && 
        func_validation.isObjectNotEmpty(cookieValue)) {

        let cookieValue_stringified = JSON.stringify(cookieValue);

        if (func_validation.isObjectNotEmpty(cookieOptions)) {
            cookies.set(cookieName, cookieValue_stringified, cookieOptions);
        } else cookies.set(cookieName, cookieValue_stringified);
        
        return true;
    } else return false;
}

function setCookieStringify_append(cookieName, cookieValue, cookieOptions) {
    if (func_validation.isStringTrimNotEmpty(cookieName) && 
        func_validation.isObjectNotEmpty(cookieValue)) {

        // Add current cookie value object to existing cookie value object
        // then, stringify result
        let cookieValue_cur = getCookieValueParseObj(cookieName);        
        let cookieValue_new = Object.assign(cookieValue_cur, cookieValue);
        let cookieValue_stringified = JSON.stringify(cookieValue_new);

        if (func_validation.isObjectNotEmpty(cookieOptions)) {
            cookies.set(cookieName, cookieValue_stringified, cookieOptions);
        } else cookies.set(cookieName, cookieValue_stringified);
        
        return true;
    } else return false;
}

function removeCookie(cookieName, cookieOptions) {
    if (func_validation.isStringTrimNotEmpty(cookieName)) {
        if (func_validation.isObjectNotEmpty(cookieOptions)) {
            cookies.remove(cookieName, cookieOptions);
        }
        else cookies.remove(cookieName);
        return true;
    }
    return false;
}

function removeAllCookies() {
    let cookies = getCookieAll();
    for (const property in cookies) {
        if (func_validation.isStringTrimNotEmpty(property))
            removeCookie(property, { path: '/' });
    }
}


